/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_SkipInputs */

const en_control_skip = /** @type {(inputs: Control_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const zh_control_skip = /** @type {(inputs: Control_SkipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳到正文`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Control_SkipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_skip = /** @type {((inputs?: Control_SkipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_SkipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_skip(inputs)
	return zh_control_skip(inputs)
});
export { control_skip as "control.skip" }